const DAY_MS = 24 * 60 * 60 * 1000
export const toDateParam = (date) => {
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)
    return `${date.getFullYear()}-${month}-${day}`
}
export const startOfToday = () => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return today
}
export const addDays = (date, days) => new Date(date.getTime() + days * DAY_MS)
const dateLabel = (date) => date.toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' })
export const presetRange = (days) => {
    const today = startOfToday()
    return {
        preset: days,
        from: toDateParam(addDays(today, -(days - 1))),
        to: toDateParam(addDays(today, 1)),
        label: `Last ${days} days`
    }
}
export const customRange = (start, end) => ({
    preset: 'custom',
    from: toDateParam(start),
    to: toDateParam(end),
    label: `${dateLabel(start)} – ${dateLabel(end)}`
})
const parseDateParam = (value) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '')
    return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null
}
export const rangeToParams = (range) => (range ? { preset: String(range.preset), from: range.from, to: range.to } : {})
export const rangeFromParams = (params) => {
    const preset = params.get('preset')
    const from = parseDateParam(params.get('from'))
    const to = parseDateParam(params.get('to'))
    if (!preset || !from || !to) {
        return null
    }
    if (preset === 'custom') {
        return customRange(from, to)
    }
    const days = Number(preset)
    return Number.isFinite(days) && days > 0 ? { preset: days, from: toDateParam(from), to: toDateParam(to), label: `Last ${days} days` } : null
}
export const parseTimestamp = (value) => {
    if (!value) {
        return null
    }
    const parsed = new Date(String(value).split('.')[0])
    return isNaN(parsed.getTime()) ? null : parsed
}
export const formatTimestamp = (date) =>
    date.toLocaleString(undefined, {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    })

export const relativeTime = (date, now = new Date()) => {
    const minutes = Math.round((now.getTime() - date.getTime()) / 60000)
    if (minutes < 1) return 'just now'
    if (minutes < 60) return `${minutes} min ago`
    const hours = Math.round(minutes / 60)
    if (hours < 24) return `${hours} hr${hours === 1 ? '' : 's'} ago`
    const days = Math.round(hours / 24)
    return `${days} day${days === 1 ? '' : 's'} ago`
}
export const isStale = (date, now = new Date()) => now.getTime() - date.getTime() > DAY_MS
export const formatCount = (value) => value.toLocaleString()
export const percent = (part, whole) => (whole > 0 ? Math.round((part / whole) * 100) : 0)
